"use client";

import { useEffect } from "react";

export default function HeroModelMount() {
    useEffect(() => {
        const mount = () => {
            if (
                typeof window !== "undefined" &&
                window.SmartClip &&
                typeof window.SmartClip.mountGlobalModelInto === "function"
            ) {
                window.SmartClip
                    .mountGlobalModelInto("model-container")
                    .then(() => {
                        const container = document.getElementById("model-container");
                        if (container) container.style.opacity = "1";
                    })
                    .catch((e) => {
                        console.warn("HeroModelMount: mount failed", e);
                    });
            }
        };

        const isMobile =
            typeof window !== "undefined" &&
            window.matchMedia &&
            window.matchMedia("(max-width: 767px)").matches;

        if (isMobile) {
            // On mobile: mount on interaction, with a fallback timer
            const hero =
                document.getElementById("model-container") ||
                document.getElementById("hero-poster") ||
                document.body;
            const onInteract = () => {
                clearTimeout(mobileFallback);
                mount();
                hero.removeEventListener("touchstart", onInteract);
                hero.removeEventListener("click", onInteract);
            };
            hero.addEventListener("touchstart", onInteract, { once: true, passive: true });
            hero.addEventListener("click", onInteract, { once: true });
            const mobileFallback = setTimeout(mount, 1200);
            return () => clearTimeout(mobileFallback);
        } else {
            // Desktop: mount when hero becomes visible or after a small delay
            const io = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        mount();
                        io.disconnect();
                    }
                });
            }, { threshold: 0.25 });

            const container = document.getElementById("model-container");
            if (container) io.observe(container);
            const fallback = setTimeout(() => {
                mount();
                io.disconnect();
            }, 1500);

            return () => {
                clearTimeout(fallback);
                io.disconnect();
            };
        }

    }, []);

    return null;
}


